import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TechnicalApplicationListComponent } from './technical-application-list/technical-application-list.component';
import {EditService, GridModule, SortService, ToolbarService} from '@syncfusion/ej2-angular-grids';
import {DateRangePickerModule} from '@syncfusion/ej2-angular-calendars';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SwitchModule} from '@syncfusion/ej2-angular-buttons';
import {FormsModule} from '@angular/forms';
import {ControlsModule} from '../controls/controls.module';
import {TechnicalApplicationsRoutingModule} from './technical-applications-routing.module';
import { TechnicalApplicationEditComponent } from './technical-application-edit/technical-application-edit.component';
import { TechnicalApplicationSelectImageComponent }
from './technical-application-select-image/technical-application-select-image.component';
import {ListViewModule} from '@syncfusion/ej2-angular-lists';
import { TechnicalApplicationFormComponent } from './technical-application-form/technical-application-form.component';
import { TechnicalApplicationCreateComponent } from './technical-application-create/technical-application-create.component';
import { TechnicalApplicationCategorySelectionComponent }
from './technical-application-category-selection/technical-application-category-selection.component';

@NgModule({
  declarations: [
    TechnicalApplicationListComponent,
    TechnicalApplicationEditComponent,
    TechnicalApplicationSelectImageComponent,
    TechnicalApplicationFormComponent,
    TechnicalApplicationCreateComponent,
    TechnicalApplicationCategorySelectionComponent],
  imports: [
    TechnicalApplicationsRoutingModule,
    CommonModule,
    GridModule,
    DateRangePickerModule,
    NgbModule,
    SwitchModule,
    FormsModule,
    ControlsModule,
    ListViewModule,
  ],
  providers: [
    ToolbarService,
    EditService,
    SortService
  ],
  entryComponents: [
    TechnicalApplicationSelectImageComponent,
    TechnicalApplicationCategorySelectionComponent
  ]
})
export class TechnicalApplicationsModule { }
